import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

type FeaturesListProps = {
  title?: string;
  items: { title?: string; body?: string }[];
};

const ListContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
}));

const FeatureTitle = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

const FeatureBody = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

/**
 * FeaturesList component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {FeaturesListProps} featuresListProps - The props for the FeaturesList component
 * @returns {ReactElement} The FeaturesList component
 */

export const FeaturesList = ({ title, items }: FeaturesListProps) => {
  return (
    <Container>
      {title && (
        <Typography component="h2" variant="h6">
          {title}
        </Typography>
      )}
      <ListContainer>
        {items
          .filter(
            (g) => g.body && g.title && g.body.length > 0 && g.title.length > 0
          )
          .map((item) => {
            const { title: itemTitle, body } = item;
            return (
              <Box key={itemTitle}>
                <FeatureTitle color="primary" fontWeight={500}>
                  {itemTitle}
                </FeatureTitle>
                <FeatureBody variant="body2">{body}</FeatureBody>
              </Box>
            );
          })}
      </ListContainer>
    </Container>
  );
};
